import { configureStore } from "@reduxjs/toolkit";
import storageSession from "redux-persist/lib/storage/session";
import {persistStore, persistReducer} from "redux-persist";

import cartSlice from "./slices/cartSlice";
import userSlice from "./slices/userSlice"

const persistConfig = {
    key: 'root',
    storage: storageSession,
};

const persistedCartReducer = persistReducer(persistConfig, cartSlice);
const persistedUserReducer = persistReducer(persistConfig, userSlice);

const store = configureStore({
    reducer:{
        cart: persistedCartReducer,
        user: persistedUserReducer,
    },
    middleware: (getDefaultMiddleware) => 
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

const persistor = persistStore(store);

export {persistor, store};
